import { styled } from '@material-ui/core/styles';

export const VerticalStack = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(2)
}));
